import React, { useEffect } from 'react';
import { Puzzle as PuzzlePiece } from 'lucide-react';
import Hero from './landing-comp/Hero';
import RiskSignals from './landing-comp/RiskSignals';
import FactsSection from './landing-comp/FactsSection';

function Landing() {
  useEffect(() => {
    document.title = 'TEAnimo | Concientización sobre el Autismo';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <header className="w-full bg-gradient-to-r from-blue-50 to-purple-50 p-4 md:p-6">
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <PuzzlePiece className="h-8 w-8 text-blue-600" />
            <span className="text-2xl font-bold text-blue-700">
              TEA<span className="text-purple-600">nimo</span>
            </span>
          </div>
        </div>
      </header>

      <main>
        <Hero />
        <RiskSignals />
        <FactsSection />
      </main>
    </div>
  );
}

export default Landing;